import React from 'react'

import { Dropdown, useModalContext } from '@sketch/components'
import { MoveStorageItemModal } from '../../../storageItems'
import type { ShareForShareDropdown } from './ShareActionsDropdown'

interface MoveShareActionProps {
  share: ShareForShareDropdown
  workspaceIdentifier: string
  label?: string
}

export const MoveShareAction = (props: MoveShareActionProps) => {
  const { share, workspaceIdentifier, label = 'Move To…' }: typeof props = props
  const { showModal } = useModalContext()

  return (
    <Dropdown.Item
      onClick={() =>
        showModal(MoveStorageItemModal, {
          item: share,
          workspaceIdentifier,
          parentProjectIdentifier: share.project?.identifier || null,
          originType:
            share.archivedAt || share.deletedAt ? 'stashed' : 'standard',
        })
      }
    >
      {label}
    </Dropdown.Item>
  )
}
